/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-27 09:32:54
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-06-27 11:48:01
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/topicCommonUtil.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { INPUT_VALUE_TYPE_RULE } from './config'
import { Message } from '@gcommon/gcommon-ui'
import { getParamsValue } from '@/utils/assist'
import { i18n } from '../../../AnswerSurvey'
import i18nSys from '@/locales'
/*
  添加题目选项时，控制只允许一项可以填空的处理
*/
const realI18n = [
  '/v2/front/content/surveyManagement/addSurvey',
  '/v2/front/surveyDetail',
  '/v2/front/content/surveyManagement/surveyList'
].includes(window.location.pathname)
  ? i18nSys
  : i18n
export const changeIsAddText = (value, index, state) => {
  state.editItem.topicSetting.topicOptionSetting =
    state.editItem.topicSetting.topicOptionSetting.map((item, sindex) => {
      if (sindex === index) {
        return Object.assign({}, item, { isAddText: value })
      }
      return item
    })
}
/*
  题目添加选项
*/
export const addItemClick = (index, state) => {
  state.editItem.topicSetting.topicOptionSetting.splice(index + 1, 0, {
    optionName: '', //选项name
    optionId: '', //选项ID
    isEncryption: false,
    isAddText: false, //是否允许填空
    isRequire: false, //是否必填
    format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
    isFixedNo: false, //是否固定选项
    imgSrc: [], //选择题图片收集
    isImgFirst: false //选择题图片是否在前收集
  })
}

/*
  题目删除选项
*/

export const minusItemClick = async (index, state, isDeleteOptionFn) => {
  //获取url上的问卷id
  const surveyId = getParamsValue('surveyId')
  //需要判断是否可以删除
  const item = state.editItem.topicSetting.topicOptionSetting[index]
  if (item.optionId) {
    //说明已经保存过的数据
    const data = await isDeleteOptionFn({
      surveyId,
      optionId: item.optionId
    })
    if (data.code != 200) {
      return data
    }
  }
  state.editItem.topicSetting.topicOptionSetting.splice(index, 1)
  //如果设置了最多选多少项，需要做处理
  if (
    state.editItem.topicSetting.optionLengthLessThan &&
    state.editItem.topicSetting.optionLengthLessThan >
      state.editItem.topicSetting.topicOptionSetting.length
  ) {
    state.editItem.topicSetting.optionLengthLessThan =
      state.editItem.topicSetting.topicOptionSetting.length
  }
}

/*
  当切换选项随机排列时的特殊处理
*/
export const changeRandomOrder = (value, state) => {
  state.editItem.topicSetting.isRandomOrder = value
  //当value为false时，需要把表格固定选项位置选项置空
  if (!value) {
    state.editItem.topicSetting.topicOptionSetting =
      state.editItem.topicSetting.topicOptionSetting.map((item) => {
        return Object.assign({}, item, { isFixedNo: false })
      })
  }
}

/*
  输入框字符判断
*/

export const blurInput = (value, sitem, state, emit) => {
  let svalue = value.target.value?.toString()?.trim()
  let options = state.editItem.topicSetting.topicOptionSetting
  options.forEach((element) => {
    state.editItem['inputErrorTips_' + element.optionId] = ''
  })
  //判断失去焦点的输入框是否是被选中的选项
  if (state.editItem.value === sitem.optionId) {
    //需要做数据验证
    if (sitem.isRequire) {
      //必填项
      if (!svalue) {
        state.editItem['inputErrorTips_' + sitem.optionId] =
          realI18n.t('survy.plccontent')
        emit('answer', state.editItem)
        return
      }
    } else {
      if (!svalue) {
        state.editItem['inputErrorTips_' + sitem.optionId] = ''
        return
      }
    }
    //字符类型
    if (sitem.format) {
      let reg = INPUT_VALUE_TYPE_RULE[sitem.format].reg
      let name = realI18n.t(`survy.${sitem.format}`)
      // console.log(name)
      if (!reg.test(svalue)) {
        state.editItem['inputErrorTips_' + sitem.optionId] = `${realI18n.t(
          'common.enterPlaceholder'
        )}${name}`
        emit('answer', state.editItem)
        return
      }
    }
  }

  state.editItem['inputErrorTips_' + sitem.optionId] = ''
  emit('answer', state.editItem)
}

/*
  多选题输入框字符判断
*/

export const blurCheckInput = (value, sitem, state, emit) => {
  let svalue = value.target.value.toString()?.trim()
  let options = state.editItem.topicSetting.topicOptionSetting
  options.forEach((element) => {
    //当没有被选中的就置空错误提示
    if (!state.editItem.values.includes(element.optionId)) {
      state.editItem['inputErrorTips_' + element.optionId] = ''
    }
  })
  //判断失去焦点的输入框是否是被选中的选项
  if (state.editItem.values.includes(sitem.optionId)) {
    //需要做数据验证
    if (sitem.isRequire) {
      //必填项
      if (!svalue) {
        state.editItem['inputErrorTips_' + sitem.optionId] =
          realI18n.t('survy.plccontent')
        emit('answer', state.editItem)
        return
      }
    } else {
      if (!svalue) {
        state.editItem['inputErrorTips_' + sitem.optionId] = ''
        return
      }
    }
    //字符类型
    if (sitem.format) {
      let reg = INPUT_VALUE_TYPE_RULE[sitem.format].reg
      let name = realI18n.t(`survy.${sitem.format}`)
      if (!reg.test(svalue)) {
        state.editItem['inputErrorTips_' + sitem.optionId] = `${realI18n.t(
          'common.enterPlaceholder'
        )}${name}`
        emit('answer', state.editItem)
        return
      }
    }
  }
  state.editItem['inputErrorTips_' + sitem.optionId] = ''
  emit('answer', state.editItem)
}

const isNoAnswer = (item) => {
  let flag = false
  if (!(!item.value && item.value !== 0)) {
    flag = true
  }
  if (item.values.length > 0) {
    flag = true
  }
  let topicOptions = item.topicSetting.topicOptionSetting || []
  topicOptions.forEach((el, index) => {
    if (item['inputValue_' + el.optionId]) {
      flag = true
    }
  })
  item.matrixValue.forEach((sitem) => {
    if (Array.isArray(sitem.value)) {
      if (sitem.value.length > 0) {
        flag = true
      }
    } else {
      if (!(!sitem.value && sitem.value !== 0)) {
        flag = true
      }
    }
  })
  return flag
}

/*
  提交问卷时,校验
*/

export const commitAnswerSurvey = (topics) => {
  //提交问卷
  //需要做数据校验,选择选中的值都维护在value/values/inputValue/matrixValue
  let noAnswerIndex = ''
  let flag = true
  const input_radio_type = [4, 10, 11, 17, 8, 12, 22, 23] // 输入题、下拉题、nps题、量标题  判断value字段
  const radio_type = [1, 20]
  const upload_type = [19] //upload
  const select_type = [2, 21] //多选题，校验values
  const matrix_type = [3, 14, 18] //矩阵单选、矩阵nps、矩阵量标题, 判断字段matrixValue 数组的value
  const matrix_nps_type = 18
  const matrix_select_type = [9] //矩阵多选题、判断字段matrixValue 数组的value的length
  for (let i = 0; i < topics.length; i++) {
    let item = topics[i]
    if (!item.display) {
      //是否非必填
      continue
    }
    if (item.topicSetting.isAllowNull) {
      //当是否非必答还需添加当有值时的判断(有值时仍然需要满足规则)
      if (!isNoAnswer(item)) {
        continue
      }
    }
    //输入、单选题时校验，当format存在还需校验字符类型
    if (input_radio_type.includes(item.topicType)) {
      if (!item.value && item.value !== 0) {
        //判断是否有值
        item.isShowTitleError = true
        item.titleErrorTips = i18n.t('survy.unfinished')
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      } else {
        let format = INPUT_VALUE_TYPE_RULE[item.topicSetting.format] //如果有数据格式要求
        if (format) {
          //判断输入的值是否满足格式
          if (!format.reg.test(item.value)) {
            // 邮箱
            if (item.topicType === 23) {
              item.inputErrorTips = realI18n.t(`survy.emailFormat`)
            } else if (item.topicType === 22) {
              item.inputErrorTips = realI18n.t(`survy.phoneFormat`)
            } else if (item.topicType === 4) {
              if (format === 'phone') {
                item.inputErrorTips = realI18n.t(`survy.phoneFormat`)
              } else if (format === 'email') {
                item.inputErrorTips = realI18n.t(`survy.emailFormat`)
              } else {
                item.inputErrorTips =
                  `${realI18n.t('common.enterPlaceholder')}` +
                  realI18n.t(`survy.${item.topicSetting.format}`)
              }
            } else {
              item.inputErrorTips =
                `${realI18n.t('common.enterPlaceholder')}` +
                realI18n.t(`survy.${item.topicSetting.format}`)
            }

            item.isShowInputError = true
            flag = false
            noAnswerIndex += item.order + '、'
            continue
          }
        }
      }
    }

    //如果是单选时，需要判断当前选中的值是否是有输入框的
    if (radio_type.includes(item.topicType)) {
      //先判断是否选择了值
      if (!item.value && item.value !== 0) {
        //判断是否有值
        item.isShowTitleError = true
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
      //先判断是哪一项有输入框
      let topicOptions = item.topicSetting.topicOptionSetting || []
      let inputIndex = 100 //输入框的索引
      let radioIndex = 1000 //选项值的索引
      let isRequire = false //输入框是否必填
      let format = ''
      let i18nFormat = ''
      let optionId = ''
      topicOptions.forEach((el, index) => {
        if (el.isAddText && el.optionId === item.value) {
          inputIndex = index
          optionId = el.optionId
          isRequire = el.isRequire
          format = INPUT_VALUE_TYPE_RULE[el.format] //如果有数据格式要求
          i18nFormat = el.format
        }
        if (el.optionId === item.value) {
          radioIndex = index
        }
      })

      if (inputIndex === radioIndex) {
        //如果选中的值正好有输入框的时候
        if (isRequire) {
          //先处理不能为空
          let ivalue = item['inputValue_' + optionId]
          if (!ivalue) {
            item['inputErrorTips_' + optionId] = realI18n.t('survy.plccontent')
            flag = false
            noAnswerIndex += item.order + '、'
            continue
          } else {
            if (format) {
              if (!format.reg.test(ivalue)) {
                item['inputErrorTips_' + optionId] =
                  `${realI18n.t('common.enterPlaceholder')}` +
                  realI18n.t(`survy.${i18nFormat}`)
                flag = false
                noAnswerIndex += item.order + '、'
                continue
              }
            }
          }
          item['inputErrorTips_' + optionId] = ''
        } else {
          let ivalue = item['inputValue_' + optionId]
          if (ivalue || ivalue === 0) {
            if (format) {
              if (!format.reg.test(ivalue)) {
                item['inputErrorTips_' + optionId] =
                  `${realI18n.t('common.enterPlaceholder')}` +
                  realI18n.t(`survy.${i18nFormat}`)
                flag = false
                noAnswerIndex += item.order + '、'
                continue
              }
            }
          }
        }
      }
    }

    if (select_type.includes(item.topicType)) {
      if (item.values.length === 0) {
        //判断是否有值
        item.isShowTitleError = true
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
      if (
        item.topicSetting.optionLengthMoreThan &&
        item.values.length < item.topicSetting.optionLengthMoreThan
      ) {
        item.isShowTitleError = true
        item.titleErrorTips = `${realI18n.t('survy.lesschose')} ${
          item.topicSetting.optionLengthMoreThan
        } ${realI18n.t('survy.item')}`
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
      //判断输入框提示
      let topicOptions = item.topicSetting.topicOptionSetting || []
      topicOptions.forEach((elem) => {
        let ivalue = item['inputValue_' + elem.optionId]
        let format = INPUT_VALUE_TYPE_RULE[elem.format]
        if (item.values.includes(elem.optionId)) {
          //当前选项被选中
          if (elem.isAddText) {
            if (elem.isRequire) {
              //是否必须填写，判断空
              if (!ivalue && ivalue !== 0) {
                item['inputErrorTips_' + elem.optionId] =
                  realI18n.t('survy.plccontent')
                flag = false
                noAnswerIndex += item.order + '、'
              } else {
                if (format) {
                  if (!format.reg.test(ivalue)) {
                    item['inputErrorTips_' + elem.optionId] =
                      `${realI18n.t('common.enterPlaceholder')}` +
                      realI18n.t(`survy.${elem.format}`)
                    flag = false
                    noAnswerIndex += item.order + '、'
                  }
                }
              }
            } else {
              if (ivalue || ivalue === 0) {
                if (format) {
                  if (!format.reg.test(ivalue)) {
                    item['inputErrorTips_' + elem.optionId] =
                      `${realI18n.t('common.enterPlaceholder')}` +
                      realI18n.t(`survy.${elem.format}`)
                    flag = false
                    noAnswerIndex += item.order + '、'
                  }
                }
              }
            }
          }
        }
      })
    }

    if (matrix_type.includes(item.topicType)) {
      let filterMatrixValue = item.matrixValue.filter((sitem) => {
        //需要对NPS题做特殊处理
        if (item.topicType === matrix_nps_type) {
          return !sitem.value && sitem.value !== 0
        } else {
          return !sitem.value
        }
      })
      if (filterMatrixValue.length > 0) {
        item.isShowTitleError = true
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
    }

    if (matrix_select_type.includes(item.topicType)) {
      let filterMatrixValue = item.matrixValue.filter(
        (sitem) => !sitem.value.length
      )
      if (filterMatrixValue.length > 0) {
        item.isShowTitleError = true
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
    }
    if (upload_type.includes(item.topicType)) {
      if (!item.value || item.value === 0 || item.value === '[]') {
        //判断是否有值
        item.isShowTitleError = true
        flag = false
        noAnswerIndex += item.order + '、'
        continue
      }
    }
  }
  if (!flag) {
    if (noAnswerIndex) {
      let bnoAnswerIndex = noAnswerIndex.slice(0, noAnswerIndex.length - 1)
      noAnswerIndex = [...new Set(bnoAnswerIndex.split('、'))].join('、')
    }
    if (realI18n.locale === 'en') {
      Message.error(
        `There was an error on your page. Please correct any required fields and submit again`
      )
    } else {
      const needJumpIndex = noAnswerIndex.split('、')[0]
      document.getElementById(`topicId${needJumpIndex}`)?.scrollIntoView()
      Message.error(
        `${realI18n.t('common.tips')}: ${realI18n.t(
          'survy.Non'
        )}${noAnswerIndex} ${realI18n.t('survy.quesUnfinish')}`
      )
    }
  }
  // console.log(topics);
  return flag
}

export const getRandomList = (optionsList) => {
  /* 是否需要随机排序 */
  let fixedIndex: Array<number> = []
  let noFixedList: Array<Object> = []
  let filterList: Array<Object> = []
  //获取哪些是需要固定排序的
  optionsList.forEach((elem, index) => {
    if (elem.isFixedNo) {
      fixedIndex.push(index)
    } else {
      noFixedList.push(elem)
    }
  })

  optionsList.forEach((item, index) => {
    if (fixedIndex.includes(index)) {
      filterList.push(item)
    } else {
      //从不需要固定的元素里面随机获取一个，并进行删除
      let len = noFixedList.length
      let randomIndex = Math.floor(Math.random() * len)
      filterList.push(noFixedList[randomIndex])
      noFixedList.splice(randomIndex, 1)
    }
  })
  return filterList
}

//最多最少选项控制
export const getMinMaxValue = (value, maxValue) => {
  if (!value && value !== 0) {
    return value
  }
  const val = Math.abs(parseInt(value))
  return val > 0 ? (val > maxValue ? maxValue : val) : 1
}
